<template>
  <div>
    <!-- <p class="detailTop">
      Below you can change the default settings for a Work Request portal. Make
      it your own and if you have any questions please don't hesitate to reach
      out!
    </p>
    <vs-divider /> -->
    <p class="detail2">Basic Settings</p>

   
    <!-- <pre>{{ basicSettings }}</pre> -->
    <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Location</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select class="selectWR" v-model="basicSettings.location.value">
          <vs-select-item
            :key="item"
            :value="item"
            :text="item"
            v-for="item in locationList"
          />
        </vs-select>
      </vs-col>
    </vs-row>
     <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Template name</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-input class="selectWR" v-model="basicSettings.templatename" />
      </vs-col>
    </vs-row>
    <!-- <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight"
          >Comments are also sent to the Work Requester</span
        >
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-checkbox class="ml-1" v-model="checkBox1"></vs-checkbox>
      </vs-col>
    </vs-row> -->
    <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Subject</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select class="selectWR" v-model="basicSettings.titleWR.value">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsBasic"
          />
        </vs-select>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Detail</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select class="selectWR" v-model="basicSettings.description.value">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsBasic"
          />
        </vs-select>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Your Name</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select class="selectWR" v-model="basicSettings.nameRequester.value">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsBasic"
          />
        </vs-select>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Your Phone Number</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select
          class="selectWR"
          v-model="basicSettings.phoneRequester.value"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsBasic"
          />
        </vs-select>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Your Email</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select
          class="selectWR"
          v-model="basicSettings.emailRequester.value"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsBasic"
          />
        </vs-select>
      </vs-col>
    </vs-row>
    <!-- <vs-row vs-w="12" class="conItemTop">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Which item is having an issue?</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select class="selectWR" v-model="basicSettings.location.value">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsBasic"
          />
        </vs-select>
      </vs-col>
    </vs-row> -->
    <vs-row
      v-if="[1, 2].includes(basicSettings.location.value)"
      vs-w="12"
      class="conItemBottom"
    >
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Hint</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-input class="selectWR" v-model="basicSettings.location.hint" />
      </vs-col>
    </vs-row>
    <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Priority level</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select class="selectWR" v-model="basicSettings.priority.value">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsBasic"
          />
        </vs-select>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Due date for this request</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select class="selectWR" v-model="basicSettings.compleDate.value">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsBasic"
          />
        </vs-select>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Attach a picture</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select class="selectWR" v-model="basicSettings.attachPicture.value">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsBasic"
          />
        </vs-select>
      </vs-col>
    </vs-row>
    <vs-divider />
    <p class="detail2">Advanced Settings</p>
    <!-- <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Title</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-input class="selectWR" v-model="basicSettings.titleAdvan.value" />
      </vs-col>
    </vs-row> -->
    <!-- <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Use Custom WR Template</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select class="selectWR" v-model="basicSettings.priority">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsBasic"
          />
        </vs-select>
      </vs-col>
    </vs-row> -->

    <div
      :id="'itemCustomField' + index"
      v-for="(find, index) in basicSettings.customField"
      :key="index"
    >
      <vs-row vs-w="12" class="conItemTop">
        <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
          <span class="headerRight">Custom Detail {{ index + 1 }}</span>
        </vs-col>
        <vs-col
          vs-type="flex"
          style="align-items: center"
          vs-lg="5"
          vs-sm="4"
          vs-xs="5"
        >
          <vs-select class="selectWR" v-model="find.value">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in optionsBasic"
            />
          </vs-select>
        </vs-col>
        <vs-icon
          color="primary"
          class="cursor-pointer"
          @click="removeCustomField(index)"
          icon="delete"
          size="17px"
        ></vs-icon>
      </vs-row>
      <vs-row v-if="[1,2].includes(find.value)" vs-w="12" class="conItemBottom">
        <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
          <span class="headerRight">Name</span>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
          <vs-input class="selectWR" v-model="find.name" />
        </vs-col>
      </vs-row>
    </div>

    <vs-row vs-w="12" class="conItemTop">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <!-- <span   class="headerRight">Custom Field </span> -->
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-button
          icon="add"
          size="small"
          @click="addCustomField"
          class="rounded-pill"
          color="success"
          type="filled"
          >Add Custom Field</vs-button
        >
      </vs-col> </vs-row
    ><br />
    <!-- <vs-row vs-w="12" class="conItemTop">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Custom Field 2</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select
          class="selectWR"
          v-model="basicSettings.customField[1].value"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsBasic"
          />
        </vs-select>
      </vs-col>
    </vs-row>
    <vs-row
      v-if="[2].includes(basicSettings.customField[1].value)"
      vs-w="12"
      class="conItemBottom"
    >
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Name</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-input
          class="selectWR"
          v-model="basicSettings.customField[1].name"
        />
      </vs-col>
    </vs-row> -->
    <!-- <vs-row vs-w="12" class="conItemTop">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Custom Field 3</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-select
          class="selectWR"
          v-model="basicSettings.customField[2].value"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in optionsBasic"
          />
        </vs-select>
      </vs-col>
    </vs-row>
    <vs-row
      v-if="[2].includes(basicSettings.customField[2].value)"
      vs-w="12"
      class="conItemBottom"
    >
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Name</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-input
          class="selectWR"
          v-model="basicSettings.customField[2].name"
        />
      </vs-col>
    </vs-row> -->

    <div
      :id="'itemCustomDropdown' + index"
      v-for="(find, index) in basicSettings.customDropdown"
      :key="index"
    >
      <vs-row vs-w="12" class="conItemTop">
        <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
          <span class="headerRight">Custom Dropdown {{ index + 1 }}</span>
        </vs-col>
        <vs-col
          vs-type="flex"
          style="align-items: center"
          vs-lg="5"
          vs-sm="4"
          vs-xs="5"
        >
          <vs-select class="selectWR" v-model="find.value">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in optionsBasic"
            />
          </vs-select>
        </vs-col>
        <vs-icon
          color="primary"
          class="cursor-pointer"
          @click="removeCustomDropdown(index)"
          icon="delete"
          size="17px"
        ></vs-icon>
      </vs-row>
      <vs-row v-if="[1,2].includes(find.value)" vs-w="12" class="conItemBetween">
        <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
          <span class="headerRight">Name</span>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
          <vs-input class="selectWR" v-model="find.name" />
        </vs-col>
      </vs-row>
      <!-- <pre>{{find}}</pre> -->
      <vs-row
        v-if="[1,2].includes(find.value)"
        vs-w="12"
        class="onItemOption mt-2"
      >
        <vs-col
          class="mr-1"
          style="padding: 5px"
          vs-lg="5"
          vs-sm="4"
          vs-xs="12"
        >
          <span class="headerRight">Options</span>
        </vs-col>
        <!-- {{find.options}} -->
        <vs-col vs-lg="5" vs-sm="4" vs-xs="12">
          <draggable
            :list="find.options"
            :disabled="!enabled"
            class="list-group"
            ghost-class="ghost"
            @start="dragging = true"
            @end="dragging = false"
          >
            <div
              class="mb-2"
              style="display: flex; align-items: center; cursor: all-scroll"
              v-for="(findOptions, i) in find.options"
              :key="i"
            >
              <vs-icon size="17px" icon="dehaze"></vs-icon>
              <!-- <span class="mr-2">{{ i + 1 }}</span> -->
              <vs-input class="selectWR ml-2" v-model="findOptions.value" />
              <vs-icon
                icon="delete"
                @click="removeDropdownItem(i)"
                size="17px"
              ></vs-icon></div
          ></draggable>
          <vs-button
            icon="add"
            size="small"
            @click="addOption(index)"
            class="rounded-pill"
            color="success"
            type="flat"
            >Add Option</vs-button
          >
        </vs-col>
      </vs-row>
    </div>
    <vs-row vs-w="12" class="conItemTop">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <!-- <span   class="headerRight">Custom Field </span> -->
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <vs-button
          icon="add"
          size="small"
          @click="addCustomDropdown"
          class="rounded-pill"
          color="success"
          type="filled"
          >Add Custom Dropdown</vs-button
        >
      </vs-col> </vs-row
    ><br />
    <vs-row vs-w="12" class="conItem">
      <vs-col class="mr-1" style="padding: 5px" vs-lg="5" vs-sm="4" vs-xs="6">
        <span class="headerRight">Logo</span>
      </vs-col>
      <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="5">
        <div v-if="!basicSettings.logo" class="upload-btn-wrapper">
          <vs-button
            color="success"
            size="small"
            icon="cloud_upload"
            class="rounded-pill"
            type="filled"
            >Upload a file</vs-button
          >
          <input type="file" @change="onFileChange" name="myfile" />
        </div>
        <div id="preview">
          <img
            v-if="basicSettings.logo"
            style="width: 150px; heigth: 150px"
            :src="basicSettings.logo"
          />
          <vs-icon
            v-if="basicSettings.logo"
            color="primary"
            class="cursor-pointer"
            @click="removeLogo"
            icon="delete"
            size="17px"
          ></vs-icon>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import draggable from "vuedraggable";
// import Draggable from 'vuedraggable'
export default {
  props: {
    itemCustom: Array,
    basicSettings: Array,
    locationList: Array,
  },
  components: {
    draggable,
  },
  data: () => ({
    enabled: true,
    dragging: false,
    select1: "",
    optionsBasic: [
      { text: "Exclude this question", value: 0 }, // Hide
      { text: "Include as an optional question", value: 1 }, // Show
      { text: "Include as a mandatory question", value: 2 },
    ],
    url: null,
  }),
  methods: {
    removeLogo() {
      this.basicSettings.logo = "";
    },
    onFileChange(e) {
      const file = e.target.files[0];
      console.log(file);
      this.url = URL.createObjectURL(file);
      this.basicSettings.logo = this.url;
      this.basicSettings.logo.push(file);
    },
    removeCustomField(item) {
      //  var el = document.getElementById("itemCustomField" + item);
      // el.remove();
      const array = this.basicSettings.customField;
      const index = array.length;
      if (index > -1) {
        array.splice(item, 1);
      }
    },
    removeCustomDropdown(item) {
      // var el = document.getElementById("itemCustomDropdown" + item);
      // el.remove();
      const array = this.basicSettings.customDropdown;
      const index = array.length;
      if (index > -1) {
        array.splice(item, 1);
      }
    },
    removeDropdownItem(item) {
      const array = this.basicSettings.customDropdown.options;
      const index = array.length;
      if (index > -1) {
        array.splice(item, 1);
      }
    },
    addCustomField() {
      this.basicSettings.customField.push({ name: "", value: "" });
      // this.finds.push({ value: '' });
    },
    addCustomDropdown() {
      this.basicSettings.customDropdown.push({
        name: "",
        value: "",
        options: [],
      });
      // this.finds.push({ value: '' });
    },
    addOption(item) {
      this.basicSettings.customDropdown[item].options.push({ value: "" });
      // this.finds.push({ value: '' });
    },
  },
  mounted() {
    // this.basicSettings = [];
   
  },
};
</script>

<style scoped>
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.upload-btn-wrapper input[type="file"] {
  /* font-size: 100px; */
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.selectWR {
  font-size: 0.75rem;
  width: 100%;
}
.conItem {
  align-items: center;
  margin: 20px 0;
}
.conItemTop {
  align-items: center;
  margin: 20px 0 5px;
}
.conItemBetween {
  align-items: center;
  margin: 5px 0 5px;
}
.conItemOption {
  margin: 5px 0 20px;
}
.conItemBottom {
  align-items: center;
  margin: 5px 0 20px;
}
.detailTop {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.8);
}
.detail2 {
  font-size: 1rem;
  color: #32c040;
  font-weight: 500;
}
.headerRight {
  /* white-space: nowrap; */
  font-size: 0.75rem;
}
</style>